import styled from 'styled-components'

const UL = styled.div`
  margin-top: initial;
  magin-right: initial;
  margin-bottom: 14px;
  margin-left: 21px;
  padding-top: initial;
  padding-right: initial;
  padding-bottom: initial;
  padding-left: initial;
  @media(max-width: 767px) {
    margin-left: 12px;
    margin-bottom: 0;
  }
`

export default UL
